/* @kdd-custom — « Le cahier du disquaire » : repli en teaser (20.08).
   Le texte complet est rendu par le serveur (SEO + lisible sans JS). Ce
   script se contente de le REPLIER quand il est long, et d'ajouter le
   déclencheur souligné. Les états n'existent donc que sous les attributs
   posés ici : sans JavaScript, tout reste ouvert, rien n'est masqué. */
(function () {
  var SEUIL = 300; /* px : en dessous, le repli n'apporte rien */

  function init() {
    document.querySelectorAll('[data-kdd-cahier]').forEach(function (racine) {
      if (racine.hasAttribute('data-kdd-cahier-actif')) return;
      var rte = racine.querySelector('.kdd-ch__rte');
      var bouton = racine.querySelector('[data-kdd-cahier-bouton]');
      if (!rte || !bouton) return;
      if (rte.scrollHeight <= SEUIL) return; /* texte court : on laisse tel quel */

      var plus = racine.getAttribute('data-kdd-cahier-plus') || 'Lire la suite';
      var moins = racine.getAttribute('data-kdd-cahier-moins') || 'Réduire';

      racine.setAttribute('data-kdd-cahier-actif', '');
      racine.setAttribute('data-kdd-cahier-replie', '');
      bouton.textContent = plus;
      bouton.setAttribute('aria-expanded', 'false');

      bouton.addEventListener('click', function () {
        var replie = racine.hasAttribute('data-kdd-cahier-replie');
        if (replie) {
          racine.removeAttribute('data-kdd-cahier-replie');
          bouton.textContent = moins;
          bouton.setAttribute('aria-expanded', 'true');
        } else {
          racine.setAttribute('data-kdd-cahier-replie', '');
          bouton.textContent = plus;
          bouton.setAttribute('aria-expanded', 'false');
          racine.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
